import { CardWrapper } from "./CardWrapper";
import { Stack, Typography } from "@mui/material";
import { TextBlock } from "./TextBlock";
import { KeepInMindIcon } from "../../../images";

export const CardList = ({
  title,
  items,
}: {
  title: string;
  items: string[];
}) => {
  return (
    <CardWrapper isCard={true} backgroundColor={"#F7F7F7"} padding={"24px"}>
      <Stack gap="16px">
        <Typography
          component="h4"
          sx={{
            fontSize: "18px",
            lineHeight: "22px",
            fontWeight: 600,
            color: "#333333",
          }}
        >
          {title}
        </Typography>
        <Stack gap="12px" paddingLeft="8px">
          {items.map((text) => (
            <Stack
              key={text}
              flexDirection="row"
              gap="12px"
              alignItems="flex-start"
            >
              <KeepInMindIcon style={{ paddingTop: "6px" }} />
              <TextBlock text={[text]} />
            </Stack>
          ))}
        </Stack>
      </Stack>
    </CardWrapper>
  );
};
